import React from "react";
const Button = ({ text, type, loading, processingLabel, margin, handleClick }) => {
  const buttonTheme = window.post_template.checkout_v4_global_components?.checkout_v4_components_btnTheme;

  return (
    <button
      onClick={handleClick}
      data-testid="cc-complete-order"
      style={{ marginTop: margin && margin + "px" }}
      className="button button--submit"
      id="hook-form"
      type={type}
      theme={buttonTheme}
      loading={`${String(loading)}`}
    >
      <span className="processing">{processingLabel}</span>
      <span className="cta__loading"></span>
      <span className="submit__text">{text}</span>
    </button>
  );
};

export default Button;
